import React, { useState, useEffect, useCallback } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { debounce } from "lodash";
import PasswordInfo from "./PasswordInfo";
import AppTooltip from "./AppTooltip";
import useStyles from "./Styles";

const PasswordField = (props) => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(props.value || "");
  const [conditions, setConditions] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });

  const checkConditions = useCallback((password) => {
    setConditions({
      length: password.length >= 8 && password.length <= 20,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[@$!%*?#^&]/.test(password),
    });
  }, []);

  const debouncedCheckConditions = useCallback(debounce(checkConditions, 300), []);

  useEffect(() => {
    debouncedCheckConditions(password);
  }, [password, debouncedCheckConditions]);

  const handleClickShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const handleMouseDownPassword = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleChange = useCallback((event) => {
    setPassword(event.target.value);
    props.onChange(event);
  }, [props]);

  const isValidPassword = Object.values(conditions).every(Boolean) && !props?.reEnterPasswordValid;

  return (
    <>
      <AppTooltip title={<PasswordInfo conditions={conditions} />} placement="right" arrow>
        <TextField
          {...props}
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={handleChange}
          className={isValidPassword ? classes.validTextField : ""}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </AppTooltip>
    </>
  );
};

export default PasswordField;
